import eventsLocal from "../../data/events";

// helper untuk ubah watch?v jadi embed
function toEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/v=([^&]+)/);
  if (match) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }
  return url;
}

function RecordingsTab({ event }) {
  // cari offline event berdasarkan public_id
  const offlineEvent = eventsLocal.find(
    (e) => e.event_public_id === event?.event_public_id
  );

  // recording bisa dari API atau offline, lalu convert ke embed
  const recordingUrl = toEmbedUrl(
    event?.recording_link || offlineEvent?.recording_link
  );

  if (!recordingUrl) {
    return <p className="text-gray-500">Recording not available.</p>;
  }

  return (
    <div className="w-full">
      <div className="relative w-full overflow-hidden rounded aspect-video">
        <iframe
          src={recordingUrl}
          title={event?.title || offlineEvent?.title}
          className="w-full h-full border-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default RecordingsTab;
